import React, { useState } from 'react';
import { FiArrowRight, FiArrowUpRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { portfolioArchive, type PortfolioProject } from '../data/portfolio';

type Filter = '전체' | '웹' | '앱' | '콘텐츠';

const filters: Filter[] = ['전체', '웹', '앱', '콘텐츠'];

const categoryOf = (project: PortfolioProject): Exclude<Filter, '전체'> => {
  if (project.categories.includes('콘텐츠 디자인')) return '콘텐츠';
  if (project.categories.includes('앱')) return '앱';
  return '웹';
};

const orderedProjects = [...portfolioArchive].sort((a, b) => b.date.localeCompare(a.date));

const PortfolioIndex: React.FC = () => {
  const [filter, setFilter] = useState<Filter>('전체');
  const projects = orderedProjects.filter((project) => filter === '전체' || categoryOf(project) === filter);

  return (
    <main className="sp-page">
      <section className="sp-index-hero" aria-labelledby="sp-index-title">
        <div className="studio-shell">
          <div className="sp-ruleline"><span>WORK / PORTFOLIO</span><span>001 — {String(portfolioArchive.length).padStart(3, '0')}</span></div>
          <div className="sp-index-hero-grid">
            <div>
              <p className="sp-eyebrow">SOMNIUM LIVE PROJECT ARCHIVE</p>
              <h1 id="sp-index-title">만든 프로젝트를<br/><em>한눈에.</em></h1>
            </div>
            <div className="sp-index-hero-aside">
              <strong>{String(portfolioArchive.length).padStart(2, '0')}<span>PROJECTS</span></strong>
              <p>웹사이트, 앱, 콘텐츠 작업을 한 줄씩 기록합니다. 실제로 수행한 프로젝트를 분야별로 살펴보세요.</p>
            </div>
          </div>
          <div className="sp-index-hero-foot"><span>WEB · APP · CONTENT</span><span>SCROLL TO EXPLORE ↓</span></div>
        </div>
      </section>

      <section className="sp-index-body" aria-labelledby="sp-index-list-title">
        <div className="studio-shell">
          <div className="sp-list-heading">
            <div><p className="sp-section-label">01 / ALL WORK</p><h2 id="sp-index-list-title">프로젝트 목록<span>.</span></h2></div>
            <p>새로운 작업은 이 목록에 하나씩 추가됩니다.</p>
          </div>
          <div className="sp-filterbar">
            <div className="sp-filters" aria-label="프로젝트 분야 필터">
              {filters.map((item) => (
                <button type="button" key={item} className={filter === item ? 'active' : ''} aria-pressed={filter === item} onClick={() => setFilter(item)}>
                  {item}<span>{item === '전체' ? orderedProjects.length : orderedProjects.filter((project) => categoryOf(project) === item).length}</span>
                </button>
              ))}
            </div>
            <span className="sp-filter-count">{String(projects.length).padStart(2, '0')} ENTRIES</span>
          </div>
          <div className="sp-project-list" aria-label={`${filter} 프로젝트 목록`}>
            {projects.map((project, index) => (
              <Link className="sp-project-row" key={project.slug} to={`/portfolio/${project.slug}`} aria-label={`${project.title} 프로젝트 상세 보기`}>
                <span className="sp-project-index">{String(index + 1).padStart(2, '0')}</span>
                <span className="sp-project-main"><strong>{project.title}</strong><small>{project.subtitle}</small></span>
                <span className="sp-project-kind">{categoryOf(project)}</span>
                <span className="sp-project-year">{project.date.slice(0, 4)}</span>
                <FiArrowUpRight className="sp-project-arrow" aria-hidden="true" />
              </Link>
            ))}
          </div>
          <p className="sp-list-note">* 일부 프로젝트 정보와 이미지는 계약 및 보안 범위에 맞춰 재구성하여 소개합니다.</p>
        </div>
      </section>

      <section className="sp-bottom-cta">
        <div className="studio-shell sp-bottom-cta-inner">
          <div><p className="sp-section-label">NEXT PROJECT</p><h2>다음 프로젝트를<br/>함께 만들까요<span>?</span></h2></div>
          <a href="/#contact">제작 상담하기 <FiArrowRight /></a>
        </div>
      </section>
    </main>
  );
};

export default PortfolioIndex;
